import {
  useMutation,
  UseMutationResult,
  useQuery,
  UseQueryResult,
} from 'react-query';
import type { MutationError } from '../../type';
import {
  getProfile,
  getUserProfileInfo,
  updateChildrenVisible,
  updateChildrenProfile,
  updatePassword,
  getSocialMediaData,
  updateProfileImage,
  updateProfileSocialMedia,
  updateProfileInfo,
} from './service';
import type {
  IUpdateChildVisibilityReq,
  IUpdateProfileVisibilityReq,
  IUserInfo,
  ISocialMediaData,
  IUpdateProfileImageReq,
  ISocialMediaFormData,
  IUpdateProfileInfoReq,
} from './type';

export const useGetProfile = (): UseMutationResult<
  IUserInfo[],
  MutationError,
  void
> => {
  return useMutation({
    mutationFn: () => {
      return getProfile();
    },
  });
};

export const useProfileInfo = () => {
  return useQuery({
    queryKey: ['profile-info'],
    queryFn: () => getUserProfileInfo(),
  });
};

export const useUpdateChildrenVisible = () => {
  return useMutation<any, MutationError, IUpdateChildVisibilityReq>({
    mutationKey: ['child-visibility'],
    mutationFn: (data: IUpdateChildVisibilityReq) =>
      updateChildrenVisible(data),
  });
};

export const useUpdateProfileVisible = () => {
  return useMutation<any, MutationError, IUpdateProfileVisibilityReq>({
    mutationKey: ['profile-visibility'],
    mutationFn: (data: IUpdateProfileVisibilityReq) =>
      updateChildrenProfile(data),
  });
};

export const useUpdatePassword = () => {
  return useMutation<any, MutationError, string>({
    mutationKey: ['password'],
    mutationFn: (data: string) => updatePassword(data),
  });
};

export const useGetSocialMediaData = (): UseQueryResult<
  ISocialMediaData[],
  MutationError
> => {
  return useQuery({
    queryKey: ['social-media-data'],
    queryFn: () => getSocialMediaData(),
  });
};

export const useUpdateProfileImage = () => {
  return useMutation<any, MutationError, any>({
    mutationKey: ['profile-image'],
    mutationFn: (data: IUpdateProfileImageReq) => updateProfileImage(data),
  });
};

export const useUpdateProfileSocialMedia = () => {
  return useMutation<any, MutationError, ISocialMediaFormData>({
    mutationKey: ['profile-social-media'],
    mutationFn: (data: ISocialMediaFormData) => updateProfileSocialMedia(data),
  });
};

export const useUpdateProfileInfoFn = () => {
  return useMutation<any, MutationError, IUpdateProfileInfoReq>({
    mutationKey: ['profile-profile-info'],
    mutationFn: (data: IUpdateProfileInfoReq) => updateProfileInfo(data),
  });
};
